
export const ARQUIVO_CONFIG_DESIGN = {
    page: {
        // Header sticky full-bleed — padrão em configuracoes/CONFIG_PAGE_HEADER.md
        // (mesma estrutura de respostas-rapidas / apis).
        root: "flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500",
        container: "w-full px-4 md:px-6 lg:px-8",
        stickyHeader: "sticky top-0 z-30 bg-white border-b border-[#e7e7ec]",
        pageBody: "pt-6 pb-[60px] flex flex-col gap-5",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-[18px] pb-[18px]",
            wrapper: "flex items-start gap-3.5 min-w-0",
            title: "text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]",
            subtitle: "mt-[5px] text-[13px] text-[#71717a] leading-[1.5]"
        },
        saveButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
    },
    section: {
        card: "bg-white rounded-xl border border-gray-100 p-5",
        titleWrapper: "flex items-center gap-3 mb-4",
        iconBox: "w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center text-[#7C3AED]",
        title: "text-base font-bold text-gray-900",
        subtitle: "text-xs text-gray-500 mt-0.5",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 block"
    },
    option: {
        container: "flex items-start gap-3 p-3.5 rounded-xl border transition-all cursor-pointer",
        active: "border-[#7C3AED] bg-violet-50/60",
        idle: "border-gray-200 hover:border-gray-300",
        radio: "w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5",
        radioActive: "border-[#7C3AED]",
        radioIdle: "border-gray-300",
        radioDot: "w-2 h-2 rounded-full bg-[#7C3AED]",
        title: "text-sm font-medium text-gray-900",
        description: "text-xs text-gray-500 mt-0.5"
    },
    toggle: {
        container: "flex items-center justify-between gap-4 p-3.5 rounded-xl border border-gray-200",
        label: "text-sm font-medium text-gray-900",
        description: "text-xs text-gray-500 mt-0.5"
    },
    alert: {
        container: "flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-100 rounded-xl",
        text: "text-xs text-amber-800 leading-relaxed"
    }
};
